import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = { class: "font-montserrat text-black-lp-300" }
const _hoisted_2 = { class: "justify-center items-center py-6 flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none" }
const _hoisted_3 = { class: "px-8 py-4 mb-2 rounded-t border-b border-gray-lp-400" }
const _hoisted_4 = { class: "inline-flex justify-between w-full" }
const _hoisted_5 = { class: "font-semibold text-20px mr-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "opacity-75 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: 
          `relative ${_ctx.modalWidth} max-h-full flex flex-col justify-between bg-white ${
            _ctx.customRound ? _ctx.customRound : 'rounded'
          }`
        
      }, [
        _withDirectives(_createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1),
            _createVNode("img", {
              src: _imports_0,
              class: "w-4 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
              alt: "x"
            })
          ])
        ], 512), [
          [_vShow, _ctx.isHeader]
        ]),
        _createVNode("div", {
          class: `${_ctx.isScroll && 'overflow-auto'} px-8`,
          style: {"max-height":"40rem"}
        }, [
          _renderSlot(_ctx.$slots, "content")
        ], 2),
        _withDirectives(_createVNode("div", {
          style: 
            `${_ctx.isBackgroundFooter && 'box-shadow: 0px -5px 5px -1px #e0e0e0'}`
          ,
          class: [`${_ctx.isBackgroundFooter && 'bg-gray-lp-200 z-20'}`, "items-center justify-end flex flex-row rounded-b-md text-xs px-8 py-3"]
        }, [
          _withDirectives(_createVNode(_component_button_outline, {
            custom: "px-12 mr-4 font-normal",
            title: _ctx.buttonCancelTitle,
            onClick: _ctx.onClose,
            isLoading: _ctx.isLoading,
            isDisabled: _ctx.isDisabled,
            iconLeft: _ctx.icons
          }, null, 8, ["title", "onClick", "isLoading", "isDisabled", "iconLeft"]), [
            [_vShow, _ctx.isCancelButton]
          ]),
          (_ctx.isIcon)
            ? (_openBlock(), _createBlock(_component_button_fill, {
                key: 0,
                custom: "px-6 py-2 bg-red-lp-200 font-normal",
                title: _ctx.buttonTitle,
                onClick: _ctx.onSubmit,
                isLoading: _ctx.isLoading,
                isDisabled: _ctx.isDisabled,
                iconLeft: _ctx.icons
              }, null, 8, ["title", "onClick", "isLoading", "isDisabled", "iconLeft"]))
            : (_openBlock(), _createBlock(_component_button_fill, {
                key: 1,
                custom: "px-12 bg-red-lp-200",
                title: _ctx.buttonTitle,
                onClick: _ctx.onSubmit,
                isLoading: _ctx.isLoading,
                isDisabled: _ctx.isDisabled
              }, null, 8, ["title", "onClick", "isLoading", "isDisabled"]))
        ], 6), [
          [_vShow, _ctx.isFooter]
        ])
      ], 2)
    ]),
    _hoisted_6
  ]))
}